import React from "react";
import { Button, Modal } from "../../../../components";


const EmailPreview = ({ open, onClose }) => {
  return (
    <Modal isOpen={open} onClose={onClose} title="EMAIL PREVIEW" width="max-w-4xl">

        <div className="flex items-center space-x-2">
          <span className="font-small  text-gray-500">Subject:</span>
          <span className="font-medium text-gray-900">Invoice Created</span>
        </div>

        <div className="font-small text-gray-500 mt-5">Mail Body</div>

        <div className="bg-gray-50 p-4 rounded shadow-md leading-relaxed text-gray-800 space-y-3">
          <p>Hello VDart Inc,</p>
          <p>An Invoice has been generated for you by TekTree LLC.</p>
          <p>Find the details below in brief:</p>
          <p>Invoice Number: <strong>16464</strong></p>
          <p>Invoice Amount: <strong>147833.72 USD</strong></p>
          <p>Please note that the payment is due by <strong>05/19/2025</strong>.</p>
          <p>Should you have any questions related to this invoice, please contact us as soon as possible.</p>
          <p>Thanks,<br />Ranesh Manthri.</p>
        </div>


      <div className="flex justify-end mt-6">
    
        <Button title="close" size="md" onClick={onClose} />
      
      </div>
    </Modal>
  );
};

export default EmailPreview;
